module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAssignment),
      expression: "!isAssignment"
    }],
    staticClass: "nav has-shadow"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/"
    }
  }, [_c('h2', {
    staticClass: "logo"
  }, [_vm._v("Silko")])]), (_vm.isAdmin) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/schools"
    }
  }, [_c('i', {
    staticClass: "fa fa-university"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['schools']))])]) : _vm._e(), (_vm.isAdmin || _vm.isSchool) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/teachers"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['teachers']))])]) : _vm._e(), (_vm.isAdmin || _vm.isSchool || _vm.isTeacher) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/students"
    }
  }, [_c('i', {
    staticClass: "fa fa-child"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['students']))])]) : _vm._e(), (_vm.isTeacher) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/instructions"
    }
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['instructions']))])]) : _vm._e(), (_vm.isTeacher) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/classes"
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['classes']))])]) : _vm._e(), (_vm.isTeacher) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/results"
    }
  }, [_c('i', {
    staticClass: "fa fa-chart-pie"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['results']))])]) : _vm._e(), (_vm.isStudent) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/assignments"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['assignments']))])]) : _vm._e()], 1), (_vm.user) ? _c('div', {
    staticClass: "nav-right"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.manualLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.tokens['manual']))]), _c('div', {
    staticClass: "dropdown is-right",
    class: {
      'is-active': _vm.isUsermenuDropped
    },
    attrs: {
      "id": "usermenu"
    }
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-primary': _vm.isUsermenuDropped
    },
    attrs: {
      "aria-haspopup": "true",
      "aria-controls": "dropdown-menu"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isUsermenuDropped = !_vm.isUsermenuDropped
      },
      "mouseover": function($event) {
        _vm.isUsermenuHover = true
      },
      "mouseleave": function($event) {
        _vm.isUsermenuHover = false
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user.ref.name))]), _c('span', {
    staticClass: "icon is-small",
    style: ({
      'color': (_vm.isUsermenuHover && !_vm.isUsermenuDropped) ? 'hsl(171, 100%, 41%)' : 'inherit',
      'transform': 'translateY(0.1em)'
    })
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('div', {
    staticClass: "select",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('select', {
    domProps: {
      "value": _vm.user.prefs.lang
    },
    on: {
      "input": _vm.updateLanguage
    }
  }, _vm._l((_vm.langs), function(lang) {
    return _c('option', {
      key: lang
    }, [_vm._v(_vm._s(lang))])
  }))]), _c('hr', {
    staticClass: "dropdown-divider"
  }), _c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v(_vm._s(_vm.tokens['logout']))])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-425b4d8b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 417
// module chunks = 0